import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Octopus, SecurityGroup } from '@maximizer/core/shared/domain';
import { map, Observable } from 'rxjs';
import { ContextService } from './context.service';

@Injectable()
export class SecurityGroupService {
  constructor(
    private readonly http: HttpClient,
    private readonly context: ContextService,
  ) {}
  private getRequest(key?: string): Octopus.SecurityGroupReadRequest {
    const request: Octopus.SecurityGroupReadRequest = {
      SecGroup: {
        Scope: {
          Fields: {
            Key: 1,
            DisplayValue: 1,
            MemberKeys: [
              {
                Key: 1,
                DisplayValue: 1,
              },
            ],
          },
        },
      },
    };

    if (key) {
      request.SecGroup.Criteria = {
        SearchQuery: {
          Key: {
            $EQ: key,
          },
        },
      };
    }

    return request;
  }

  get(key?: string): Observable<SecurityGroup | null> {
    const request = this.getRequest(key);

    return this.requestAndMap(request).pipe(
      map((result) => {
        if (result.length) {
          return result[0];
        }
        return null;
      }),
    );
  }

  getAll(): Observable<SecurityGroup[]> {
    const request = this.getRequest();
    return this.requestAndMap(request);
  }

  private requestAndMap(
    request: Octopus.SecurityGroupReadRequest,
  ): Observable<SecurityGroup[]> {
    return this.http
      .post<Octopus.SecurityGroupResponse>(
        `${this.context.api}${Octopus.Action.READ}`,
        request,
      )
      .pipe(
        map((result) => {
          if (
            result.Code === Octopus.ResponseStatusCode.Successful &&
            result.SecGroup?.Data
          ) {
            const mapper = new Octopus.SecurityGroupMapper();
            return mapper.from(result.SecGroup.Data);
          }

          return [];
        }),
      );
  }
}
